var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col",class:[_vm.grid.colTwo.cols, _vm.grid.colOne.greyBackground ? 'light-grey-background' : '']},[_vm._t("left-column")],2),_c('div',{staticClass:"col",class:[_vm.grid.colTwo.cols, _vm.grid.colTwo.greyBackground ? 'light-grey-background' : '']},[_vm._t("right-column")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }